import React from "react";
import { ContentSection } from "sprint-common-web";

import { FileRecordContentView } from "../../../../../common/file-record-details/content/FileRecordContentView";
import { FileRecordDetails } from "../../../../../common/file-record-details/FileRecordDetails";

interface FileRecordContentSectionProps {
    fileRecordDetails: FileRecordDetails;
    isFileRecordDetailsLoading: boolean;
}

export const FileRecordContentSection = ({
    fileRecordDetails,
    isFileRecordDetailsLoading
}: FileRecordContentSectionProps): JSX.Element => {
    return (
        <ContentSection header="File record content" isLoading={isFileRecordDetailsLoading} style={{ height: 350 }}>
            <FileRecordContentView fileRecordDetails={fileRecordDetails} />
        </ContentSection>
    );
};
